import { getToken, initializeAppCheck, ReCaptchaEnterpriseProvider, type AppCheck } from "firebase/app-check";
import { httpsCallable } from "firebase/functions";
import { getKajikajyFirebaseClient } from "./firebaseClient";
import type { WebSessionTicket } from "./webSessionHandoff";

let appCheck: AppCheck | undefined;

export function isWebSessionAccountCurrent(uid: string): boolean {
  const user = getKajikajyFirebaseClient()?.auth.currentUser;
  return Boolean(user && !user.isAnonymous && user.uid === uid);
}

export async function beginWebAppSession(codeChallenge: string, uid: string): Promise<WebSessionTicket> {
  const client = getKajikajyFirebaseClient();
  if (!client || !isWebSessionAccountCurrent(uid)) throw new Error("session-unavailable");
  const siteKey = import.meta.env.VITE_FIREBASE_APP_CHECK_SITE_KEY?.trim();
  if (!siteKey) throw new Error("attestation-unavailable");
  appCheck ??= initializeAppCheck(client.app, {
    provider: new ReCaptchaEnterpriseProvider(siteKey),
    isTokenAutoRefreshEnabled: true,
  });
  await getToken(appCheck);
  if (!isWebSessionAccountCurrent(uid)) throw new Error("session-unavailable");
  const callable = httpsCallable<{ codeChallenge: string }, WebSessionTicket & { ok: boolean }>(
    client.functions,
    "beginWebAppSession",
    { timeout: 30_000 },
  );
  const response = await callable({ codeChallenge });
  if (!isWebSessionAccountCurrent(uid) || response.data.ok !== true) throw new Error("session-unavailable");
  return response.data;
}
